<div class="loading-mask" style="min-height: 100vh">
  <i class="fal fa-spinner fa-spin fa-fw"></i>
  <span class="sr-only">Logging Off...</span>
</div>
